import React, { Fragment, useEffect, useState, useRef } from 'react'
import { Container, Row, Col, Modal, Button } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../context/auth/useAuth'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { getOrdersRestaurantToDelivery, changeToDelivered, changeToPrinted } from '../../actions/ordersActions'
import { CustomDataTable } from '../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import ReactToPrint from "react-to-print";
import { PrintOrder } from '../../components/printer/PrintOrder'
import socketClient from "socket.io-client"

export default function Ordersfordelivery() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const { client } = useAuth()
    const { restaurantid } = useParams()
	const componentRef = useRef()
	const reactToPrintRef = useRef()
	const componentRefTable = useRef()

	const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0])
    const [filteredData, setFilteredData] = useState([])
	const [activeButton, setActiveButton] = useState('today')

	const { orders, resultorder } = useSelector(state => state.orders)

    const [modalShow, setModalShow] = useState(false)
    const [orderToShow, setOrderToShow] = useState({})
	const [orderToPrint, setOrderToPrint] = useState({})
	const [printTriggered, setPrintTriggered] = useState(false)


	// Función para calcular fechas
    const calculateDate = (days) => {
        const date = new Date();
        date.setDate(date.getDate() + days); // Sumamos días
        return date.toISOString().split('T')[0];
    };
    // Filtrar pedidos según la fecha seleccionada
    useEffect(() => {
        const filteredOrders = orders?.filter(order => {
            const orderDate = new Date(order.date).toISOString().split('T')[0]; // Fecha del pedido
            return orderDate === selectedDate;
        });
        setFilteredData(filteredOrders);
    }, [orders, selectedDate])

    const handleDateChange = (event) => {
        setSelectedDate(event.target.value)
		setActiveButton(null)
    }
	const handleButtonClick = (days, buttonKey) => {
        setSelectedDate(calculateDate(days))
        setActiveButton(buttonKey)
    }

	useEffect(() => {
		if(client){
			if(client.restaurant){
				dispatch(getOrdersRestaurantToDelivery(client.restaurant))
			}else{
				dispatch(getOrdersRestaurantToDelivery(restaurantid))
			}
		}
	}, [dispatch, t, client, restaurantid])


	useEffect(() => {
		const socket = socketClient(process.env.REACT_APP_SOCKET_ADDRESS, {withCredentials:  true})
		socket.on("newOrder", data => {
			dispatch({
				type: 'ORDER_ADD_SOCKET_SUCCESS',
				payload: data
			})
		})
		socket.on("orderPrinted", data => {
			dispatch({
				type: 'ORDER_PRINTED_SOCKET_SUCCESS',
				payload: data
			})
		})
		socket.on("orderPaid", data => {
			dispatch({
				type: 'ORDER_PAID_SOCKET_SUCCESS',
				payload: data
			})
		})
	}, [dispatch])

    const showOrder = (orderid) => {
		setOrderToShow(orders?.find(order => order._id === orderid))
		setModalShow(true)
    }

	const handlePrintOrder = async (orderid) => {
		const selectedOrder = orders?.find(order => order._id === orderid)
		dispatch(changeToPrinted(orderid))
		setOrderToPrint(selectedOrder)
		setPrintTriggered(true)
	}

	useEffect(() => {
		if (printTriggered && reactToPrintRef.current && componentRefTable.current) {
		  reactToPrintRef.current.handlePrint()
		  setPrintTriggered(false)
		}
	}, [printTriggered, orderToPrint])


    const setOrderDelivered = async(e, idOrder) => {
        e.preventDefault()
		dispatch(changeToDelivered(idOrder))
	}

    useEffect(() => {
        if(resultorder){
            switch (resultorder) {
                case 'changedsuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('kitchen.orders.changedsuccess')
                    }).then(() => {
                    	setOrderToShow({})
						setModalShow(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultorder])

	const columnsOrders = [
		{
			name: t('admin.orders.paid'),
			center: true,
			width: '80px',
			cell: order => (
				<div className="text-center">
					{order?.isPaid
						? <i className="fa-solid fa-circle-check text-success fa-2x" title="Pagado"></i>
						: <i className="fa-solid fa-circle-xmark text-danger fa-2x" title="No pagado"></i>
					}
				</div>
			),
			selector: (order) => order?.isPaid,
			sortable: true
		},
		{
			name: t('admin.orders.reference'),
			cell: order =>
				<div className='text-center'>
					<strong>{order?.orderReference}</strong><br/>
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: t('admin.orders.restaurant'),
			cell: order =>
				<div>
					{order?.restaurant}
				</div>,
			selector: (order) => order?.restaurant,
			sortable: true,
			omit: !!client?.restaurant,
		},{
			name: t('admin.orders.delivery'),
			cell: order =>
			<div className='text-center'>
				{ new Date(Date.parse(order?.date)).getDate()<10 ? '0'+new Date(Date.parse(order?.date)).getDate() : new Date(Date.parse(order?.date)).getDate()}/{ new Date(Date.parse(order?.date)).getMonth()+1<9 ? '0'+parseInt(new Date(Date.parse(order?.date)).getMonth()+1) : parseInt(new Date(Date.parse(order?.date)).getMonth()+1)}/{ new Date(Date.parse(order?.date)).getFullYear()}<br/>
				{order?.hour}
			</div>,
			selector: (order) => order?.hour,
			sortable: true,
		},{
			name: t('admin.orders.client'),
			cell: order =>
				<div>
					{order?.user}
				</div>,
			selector: (order) => order?.user,
			sortable: true,
		},{
			name: t('admin.orders.dishes'),
			cell: order =>
				<div>
                    · {order?.firstdish?.name}<br/>
					· {order?.seconddish?.name}<br/>
					{order?.drink && <>· {order?.drink?.name}<br/></>}
					{order?.dessert && <>· {order?.dessert?.name}<br/></>}
                    {order?.complements?.map((complement, index) =>(
                        <Fragment key={index}>· {complement?.name}<br/></Fragment>
                    ))}
				</div>,
			selector: (order) => order?.user?.name,
			sortable: false,
		},{
			name: '',
			cell: order =>
				<div className='d-flex'>
					<i className="fa-solid fa-list fa-2x cursor me-3" onClick={() => showOrder(order?._id)}></i>
					<i className="fa-solid fa-print fa-2x cursor me-3" onClick={() => handlePrintOrder(order?._id)}></i>
				</div>,
			sortable: false,
		}
	]
	const columnsOrdersNoPrint = [
		{
			name: t('admin.orders.paid'),
			center: true,
			width: '80px',
			cell: order => (
				<div className="text-center">
					{order?.isPaid
						? <i className="fa-solid fa-circle-check text-success fa-2x" title="Pagado"></i>
						: <i className="fa-solid fa-circle-xmark text-danger fa-2x" title="No pagado"></i>
					}
				</div>
			),
			selector: (order) => order?.isPaid,
			sortable: true
		},
		{
			name: t('admin.orders.reference'),
			center : true,
			cell: order =>
				<div className='text-center'>
					<strong>{order?.orderReference}</strong><br/>
					{order?.hour}
				</div>,
			selector: (order) => order?.orderReference,
			sortable: true,
		},{
			name: 'Imprimir',
			center : true,
			cell: order =>
				<div className='d-flex'>
					<i className="fa-solid fa-print fa-2x cursor me-3" onClick={() => handlePrintOrder(order?._id)}></i>
				</div>,
			sortable: false,
		}
	]

	return (
        <Container className='p-5'> 
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to={"/kitchen/ordersdashboard/"+restaurantid}>
                        <img src="../../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
					<div className="mb-3">
						<label htmlFor="order-date" className="form-label">{t('admin.orders.selectDate')}</label>
						<input
							type="date"
							id="order-date"
							className="form-control"
							value={selectedDate}
							onChange={handleDateChange}
						/>
					</div>
					<div className="mb-3 d-flex gap-2">
						<button
							className={`btn ${activeButton === 'today' ? 'btn-primary' : 'btn-secondary'}`}
							onClick={() => handleButtonClick(0, 'today')}>
							{t('admin.orders.today')}
						</button>
						<button 
							className={`btn ${activeButton === 'tomorrow' ? 'btn-primary' : 'btn-secondary'}`} 
							onClick={() => handleButtonClick(1, 'tomorrow')}>
							{t('admin.orders.tomorrow')}
						</button>
						<button
							className={`btn ${activeButton === 'dayAfterTomorrow' ? 'btn-primary' : 'btn-secondary'}`}
							onClick={() => handleButtonClick(2, 'dayAfterTomorrow')}>
							{t('admin.orders.dayAfterTomorrow')}
						</button>
					</div>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5 ">
				<Col>

				</Col>
			</Row>
            <Row>
                <Col xs={8}>
					<h1>{t('admin.orders.ordersfordelivery')}</h1>
                    <CustomDataTable
                        columns={columnsOrders}
						data={filteredData || []}
                        printable = {false}
						exportable = {true}
						pagination = {true}
						conditionalRowStyles={[
							{
								when: row => row && row?.isPaid === false,
								style: {
								opacity: 0.3,
								pointerEvents: 'none'
								}
							}
						]}
                    />
                </Col>
				<Col xs={4}>
					<h1>{t('admin.orders.ordersforprint')}</h1>
                    <CustomDataTable
                        columns={columnsOrdersNoPrint}
                        data={filteredData?.filter(order => !order.isPrinted) || []}
                        printable = {false}
						exportable = {false}
						pagination = {false}
						conditionalRowStyles={[
							{
								when: row => row && row?.isPaid === false,
								style: {
								opacity: 0.3,
								pointerEvents: 'none'
								}
							}
						]}
                    />
                </Col>
            </Row>
			<Modal show={modalShow} onHide={() => setModalShow(false)} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
				<Modal.Header>
					<Modal.Title id="contained-modal-title-vcenter" className='w-100 d-flex justify-content-between'>
						<div>{t('admin.orders.order')}: {orderToShow?.orderReference}</div>
						<div className='cursor'><i className='fa fa-times cursor' onClick={() => setModalShow(false)}></i></div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="px-4 formulario">
						<Row className="text-start my-3">														
							<Row className='justify-content-between align-items-center'>
								<PrintOrder order={orderToShow} ref={componentRef}/>
								<Col xs={10}>
									<div className='text-uppercase fs-6 fw-bold'>{orderToShow?.user}</div><br/>
									<div className='text-uppercase fs-5 fw-bold'>{t('admin.menus.price')}: {orderToShow?.price} €</div>
									<strong>{t('admin.orders.restaurant')}: {orderToShow?.restaurant}</strong><br/><br/>
									<div className='text-uppercase fs-6 fw-bold'>{t('admin.orders.datehour')}<br/>{orderToShow?.date?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4)+' - '+orderToShow?.hour}</div><br/>
									<div className='text-uppercase fs-6 fw-bold'>{t('admin.orders.datehourorder')}<br/>{orderToShow?.orderAt?.substr(8,2)+'/'+orderToShow?.orderAt?.substr(5,2)+'/'+orderToShow?.orderAt?.substr(0,4) + ' - ' +orderToShow?.orderAt?.substr(11,5)}</div><br/>
									· {t('admin.orders.firstdish')}: {orderToShow?.firstdish?.name}<br/>
									· {t('admin.orders.seconddish')}: {orderToShow?.seconddish?.name}<br/>
									· {t('admin.orders.drink')}: {orderToShow?.drink?.name}<br/>
									· {t('admin.orders.dessert')}: {orderToShow?.dessert?.name}<br/>
									{orderToShow?.complements?.length > 0 &&
										<>
											<strong>{t('admin.orders.complements')}</strong><br/>
											{orderToShow?.complements?.map((complement, index) =>(
												<div key={index} className='ps-3'>{complement?.name}<br/></div>
											))}
										</>
									}
								</Col>
								<Col xs={2}>
									<ReactToPrint
										trigger={() => <i className='fas fa-print fa-3x cursor'></i>}
										content={() => componentRef.current}
									/>
								</Col>
							</Row>
						</Row>
						<Row className="text-start my-3">
							<Button type="button" className="btn-primary my-2 w-100" onClick={(e) => setOrderDelivered(e, orderToShow?._id)}>
								{t('admin.orders.changetodelivered')}
							</Button>
						</Row>
					</div>
				</Modal.Body>
			</Modal>
			{orderToPrint ?
				<>
					<PrintOrder order={orderToPrint} ref={componentRefTable}/>
					<ReactToPrint
						ref={reactToPrintRef}
						trigger={() => <></>}
						content={() => componentRefTable.current}
						pageStyle={
							`@media print{
								body{margin:0;padding:0}
								.printable{font-size:12px;}
							}`
						}
					/>
				</>
				:
				null
			}
        </Container>
	)
}